<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import type { ICustomFieldSchemaDTO } from "../../services/DTO";
  import { parseDate } from "../../utils/date-utils";
  import DateInput from "../Form/Fields/DateInput.svelte";
  import CustomListValueDropdown from "../Form/Fields/Dropdown/CustomListValueDropdown.svelte";
  import Input from "../Form/Fields/Input.svelte";
  import NumberInput from "../Form/Fields/NumberInput.svelte";
  import Switch from "../Form/Fields/Switch.svelte";
  import FormField from "../Form/FormField.svelte";

  const dispatch = createEventDispatcher();

  export let schema: ICustomFieldSchemaDTO = null;
  export let value: string = null;

  function setValue(v: string): void {
    value = v;
    dispatch("update", v);
  }

  function convertDate(x: any): string {
    //console.log("converting date", x);
    return (x as Date).toISOString();
  }
</script>

<FormField>
  {#if schema.customFieldType.code === "STRINGXXXX"}
    <Input
      name={schema.customFieldSchema.fieldLabel}
      placeholder=""
      required={false}
      {value}
      on:change={(v) => setValue(v.detail.toString())}
    />
  {:else if schema.customFieldType.code === "FIXNUMXXXX"}
    <NumberInput
      name={schema.customFieldSchema.fieldLabel}
      placeholder=""
      required={false}
      value={parseInt(value)}
      on:change={(v) => setValue(v.detail.toString())}
    />
  {:else if schema.customFieldType.code === "FLONUMXXXX"}
    <NumberInput
      name={schema.customFieldSchema.fieldLabel}
      placeholder=""
      required={false}
      value={parseFloat(value)}
      on:change={(v) => setValue(v.detail.toString())}
    />
  {:else if schema.customFieldType.code === "DATEXXXXXX"}
    <DateInput
      name={schema.customFieldSchema.fieldLabel}
      placeholder=""
      required={false}
      value={parseDate(value)}
      on:dateChanged={(v) => setValue(convertDate(v.detail))}
    />
  {:else if schema.customFieldType.code === "DATETIMEXX"}
    <DateInput
      name={schema.customFieldSchema.fieldLabel}
      placeholder=""
      calendarType="calendarType"
      required={false}
      value={parseDate(value)}
      on:dateChanged={(v) => setValue(convertDate(v.detail))}
    />
  {:else if schema.customFieldType.code === "BOOLEANXXX"}
    <Switch
      name={schema.customFieldSchema.fieldLabel}
      value={parseInt(value)}
      on:toggle={(v) => setValue(v.detail.toString())}
    />
  {:else if schema.customFieldType.code === "DROPDOWNXX"}
    <CustomListValueDropdown
      name={schema.customFieldSchema.fieldLabel}
      schemaId={schema.customFieldSchema.listSchemaId}
      value={parseInt(value)}
      on:select={(v) => setValue(v.detail.oid.toString())}
    />
  {/if}
</FormField>
